module.exports = __webpack_public_path__ + "media/images/pages/about_us/partners/logo_hemera-c8789b5c42e2e67433514df1aa74d24c.png";